import { render } from "./IntegrationSwitch.vue?vue&type=template&id=7ac9b552&ts=true"
import script from "./IntegrationSwitch.vue?vue&type=script&lang=ts"
export * from "./IntegrationSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__